<template>
  <div id="navBar" :class="{ inLevel2: navStatus.level == 2 }">
    <!-- <div class="back-btn">
      <div class="bg"></div>
      <div class="icon" @click="linkBack()"></div>
      <div class="title">
        <span class="level1">赛事中心</span>
        <span class="level2">{{ navStatus.name }}</span>
      </div>
    </div> -->
    <div class="nav-box">
      <div class="bg"></div>
      <ul class="nav">
        <li
          v-for="(item, key) in nav"
          :key="key"
          :class="{ active: isRouterWatched(item.name) }"
          :name="item.name"
          @click="linkTo(item.name)"
        >
          <div class="active-bg"></div>
          <div class="label-box">
            <span class="label-shadow">{{ item.label }}</span>
            <span class="label-text">{{ item.label }}</span>
          </div>
         
          <tip-dot
            v-show="item.name == 'Quiz' && showLingqu.quizHots.quizTop" 
            placement="quizs"
          ></tip-dot>
          <tip-dot
           
            v-show="item.name == 'Store' &&  showLingqu.taskHots.shopTop"
            placement="store"
          ></tip-dot>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import TipDot from '@/components/tip-dot.vue'
import * as api from '@/service/index'
export default {
  components: { TipDot },
  inject: ['json_config'],
  data() {
    return {
      clickQuizNav: false,
    }
  },
  computed: {
    ...mapState(['navStatus', 'token', 'uid', 'showLingqu', 'registration']),
    nav() {
      let temp_nav = [{ label: '赛程&奖金', name: 'Schedule' }];
      let other_nav = [
        { label: '活动&商城', name: 'Store' },
        { label: '直播', name: 'Live' },
        { label: '战队人气值', name: 'Ranking' },
        { label: '竞猜', name: 'Quiz' }, 
      ];
      if(!this.registration.switch || this.registration.testOtherModule) {
        temp_nav.push(...other_nav);
      }

      return temp_nav;
    },
    isStoreWatched() {
      return this.$route.matched.some(record => record.name === 'Store')
    }
  },
  async created() {
    if(!this.registration.switch || this.registration.testOtherModule) {
      await this.reqUserInfo(true)
      let avatar = this.$route.query?.avatar
      let taptapavatar = this.$route.query?.taptapavatar
      await this.getupdateUseavatar(avatar, taptapavatar)
    }
  },
  mounted() {
    if(!this.registration.switch || this.registration.testOtherModule) {
      this.reqRedDotState()
      this.reqMatchSimpleSeasons()
    }
  },
  methods: {
    ...mapActions(['reqUserInfo', 'reqMatchSimpleSeasons','reqRedDotState']),
    ...mapMutations(['SET_SHOWLINGQU']),
    isRouterWatched(name) {
      let isWatched = this.$route.matched.some(record => {
        if(name == 'Ranking') {
          return record.name === name || record.name === 'Detail'
        } else {
          return record.name === name
        }
      });
      return isWatched;
    },
    linkTo(name) {
      if (!this.isRouterWatched(name) && (!this.registration.switch || this.registration.testOtherModule)) {
        this.$router.push({
          name: name
        })
        // 获取竞猜币余额
        if (name != 'ranking' && name != 'Schedule'  ) {
          // LIVE reqUserInfo
          // this.reqUserInfo(false)
          this.reqRedDotState()
        }
      }
    },
    linkBack() {
      if (this.navStatus['backFn']) {
        this.navStatus['backFn']()
      } else {
        this.$router.back()
      }
    },

    hasAgeValue(arr, targetValue) {
      return arr.some((obj) => obj.status == targetValue)
    },
    async getupdateUseavatar(avatar, taptapavatar) {
      // 上传头像
      const storedAvatar = localStorage.getItem('DCavatar')
      const storedTaptapAvatar = localStorage.getItem('DCtaptapavatar')
      
      if (
        (!storedAvatar && !storedTaptapAvatar) ||
        avatar !== storedAvatar ||
        taptapavatar !== storedTaptapAvatar
      ) {
        const data = {
          avatar: avatar || 'Portrait1',
          taptapavatar: taptapavatar || ''
        }

        localStorage.setItem('DCavatar', data.avatar)
        localStorage.setItem('DCtaptapavatar', data.taptapavatar)

        if(!this.token) return;
        try {
          await api.updateUseavatar(this.token, data)
        } catch (err) {
          console.log(err)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/navBar';
</style>